const financialNumber = require('financial-number')
const padRight = require('pad-right')

const reverseString = str => str.split('').reverse().join('')
const replaceRight = (str, needle, fn) => reverseString(reverseString(str).replace(needle, fn))

function stripNonNumeric(value) {
	value = value.match(/(?:\d*\-)?\d+/g, '')
	return value ? value.join('') : ''
}

module.exports = {
	format(inputString, {
		includeSymbol = true,
		currencySymbol = '$',
		includeComma = true,
		trim = 2,
		round,
		decimalCharacter = '.',
		trimTrailing = false,
	} = {}) {
		decimalCharacter = decimalCharacter.trim()
		const trueZero = `0${decimalCharacter}00`
		let prefix = includeSymbol ? currencySymbol : ''

		if (!inputString || (typeof inputString !== 'string' && typeof inputString !== 'number')) {
			inputString = trueZero
		} else if ((typeof inputString === 'string' && typeof inputString !== 'number') && !stripNonNumeric(inputString)) {
			inputString = trueZero
		} else if (typeof inputString === 'number') {
			if (!Number.isFinite(inputString)) {
				inputString = trueZero
			} else {
				inputString = inputString.toString()
			}
		}

		if (!inputString.includes(decimalCharacter)) {
			inputString += `${decimalCharacter}00`
		}

		let numberString
		let expectedDecimalPlaces

		//financial number expects a . for the decimal character
		//we put back their decimal character before we return the new string
		numberString = inputString.split(decimalCharacter).join('.')

		if (typeof round === 'number' && round >= 0) {
			numberString = financialNumber(numberString).toString(round, financialNumber.round)
			expectedDecimalPlaces = round
		} else {
			expectedDecimalPlaces = trim
			numberString = financialNumber(numberString).toString(trim)
		}

		//Not using the decimalCharacter variable here because it's now a string from financial-number, which uses .
		let [dollars, cents] = numberString.split('.')

		const negative = dollars.toString().trim().charAt(0) === '-'

		if (negative) {
			dollars = dollars.substr(1)
			prefix = `-${prefix}`
		}

		//strip non-numeric characters
		dollars = stripNonNumeric(dollars)
		cents = stripNonNumeric(cents)

		cents = padRight(cents ? cents : '', expectedDecimalPlaces)

		if (includeComma) {
			dollars = replaceRight(dollars, /(.{3})/g, (_, triplet) => `${triplet},`)
			if (dollars.charAt(0) === ',') {
				dollars = dollars.substr(1)
			}
		}

		let output = financialNumber(`${prefix + dollars}.${cents}`).toString()

		if (trimTrailing && output.endsWith(`.00`)) {
			output = output.substring(0, output.lastIndexOf(`.00`))
		}

		return output.split('.').join(decimalCharacter)
	},
}
